export default __webpack_public_path__ + "static/media/juice-fruit-l-mobile.98c54b09.png";